import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AssetService } from 'src/app/services/asset/asset.service';
import { ClientService } from 'src/app/services/client/client.service';
import { Constants } from 'src/app/constants/constants';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { JobModel } from 'src/app/models/job.model';
import { AssetModel } from 'src/app/models/asset.model';
import { ObservationModel } from 'src/app/models/observation.model';

@Component({
  selector: 'app-modal-condmen-asset-cert',
  templateUrl: './modal-condmen-asset-cert.component.html',
  styleUrls: ['./modal-condmen-asset-cert.component.scss'],
})
export class ModalCondmenAssetCertComponent implements OnInit {

  selectedJob: JobModel;
  selectedAsset: AssetModel;
  observation: ObservationModel;
  originalObservation: ObservationModel;

  @ViewChild('popover') popover;
  isOpen = false;
  selectedField: any;


  constructor(public appearanceService: AppearanceService,
    public modalController: ModalController, public assetService: AssetService, 
    public clientService: ClientService) { }

  ngOnInit() {}


  ionViewWillEnter()
  {
    if (!this.selectedJob || !this.selectedAsset)
    {
      this.closeModal();
    }

    this.originalObservation = JSON.parse(JSON.stringify(this.observation));
  }


  openPopover(field, e: Event) 
  {
    this.selectedField = field;
    this.popover.event = e;
    this.isOpen = true;
  }


  inputSelected(choice)
  {
    switch(this.selectedField)
    {
      case 'condemnAssetIsolated':
        this.observation.condemnAssetIsolated = choice;

        if (choice == "No")
        {
          this.observation.condemnFuseRemoved = "No";
        }

        break;

      case 'condemnFuseRemoved':
        this.observation.condemnFuseRemoved = choice;

        if (choice == "Yes")
        {
          this.observation.condemnAssetIsolated = "Yes";
        }

        break;

      case 'condemnAssetSufficientLighting':
        this.observation.condemnAssetSufficientLighting = choice;
        break;

      case 'condemnAssetDangerousPosition':
        this.observation.condemnAssetDangerousPosition = choice;
        break;
    }
  }


  wasEditMade(): boolean
  {
    return JSON.stringify(this.originalObservation) != JSON.stringify(this.observation);
  }


  generateCondemnCert()
  {
    var payload = {
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      jobUid: this.selectedJob.jobUid,
      assetUid: this.selectedAsset.jobAssetUid,
      observation: this.observation,
      condemnDataChanged: false
    }

    if(this.wasEditMade())
    {
      payload.condemnDataChanged = true;
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.generateCondemnationCert(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          var returnData = { certCreated: true };
          this.closeModal(returnData);
          this.appearanceService.presentToast("Certificate Created.", Constants.TOAST_SUCCESS);
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);

        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }

  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'CondemnCertModal');
  }


}
